import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import Counter from '../components/counter'
import Team from '../components/team'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import Testimonios from '../components/testimonios'
import hero from '../assets/images/hero/quienessomos.jpg'
import About from '../components/about'
import Certificaciones from '../components/certificaciones'
import Mvv from '../components/Mvv'
import { Helmet } from 'react-helmet-async'
import metadataimage from '../assets/images/hero/ss4.jpg'

export default function Quienessomos() {
    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Quienes somos | Hospital Aranda de La Parra</title>
                <meta name="description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta property="og:title" content="Quienes somos | Hospital Aranda de La Parra" />
                <meta property="og:description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta property="og:image" content={`${basedomain}${metadataimage}`} />
                <meta property="og:url" content={`${basedomain}/quienessomos`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Quienes somos | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta name="twitter:image" content={`${basedomain}${metadataimage}`} />
                <meta itemprop="name" content="Quienes somos | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta itemprop="image" content={`${basedomain}${metadataimage}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Acerca de HAP</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Quiénes somos</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <About />
                </div>

                <div className="container mt-100 mt-60">
                    <div className="row align-items-center">
                        {/* <div className="col-lg-7 col-md-6">
                    <div className="section-title">
                        <h6 className="text-primary text-uppercase">¿Qué hemos logrado?</h6>
                        <h4 className="title mb-3">Más Allá de los Servicios Convencionales</h4>
                        <p className="text-muted para-desc mb-0">Como un hospital líder en la región, buscamos establecer una relación más allá de la atención médica tradicional, convirtiéndonos en un aliado comprometido con nuestros pacientes y las comunidades con las que trabajamos.</p>

                    </div>
                </div> */}

                        <div className="col-lg-12 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0 mx-auto">
                            <div className="position-relative">
                                <Counter />
                                {/* <div className="position-absolute top-50 start-50 translate-middle z-n1">
                                    <div className='opacity-75 p-2 mt-4'>
                                        <img src={icon} className="img-fluid w-100 mx-auto" alt="" />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section bg-inverted">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">¿Qué opinan nuestros pacientes?</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <Testimonios />
            </section>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Misión, Visión y Valores</h4>
                            </div>
                        </div>
                    </div>
                    <Mvv />
                </div>
            </section>


            <section className="section bg-inverted">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Política de Calidad</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <p>
                            En Hospital Aranda de la Parra León, estamos comprometidos en brindar servicios de salud <strong>confiables</strong> y con altos estándares de calidad, mediante una <strong>atención segura y centrada en las personas</strong>, enfocados en crear una experiencia satisfactoria; garantizando el cumplimiento de los requisitos legales aplicables y la <strong>mejora continua</strong> de los procesos del Sistema de Gestión de la Calidad para nuestros grupos de interés.

                        </p>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Certificaciones</h4>
                                <p className="text-muted para-desc mx-auto mb-0">
                                    En HAP, estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. Para lograrlo, hemos establecido alianzas estratégicas con instituciones y profesionales de la salud, con el fin de brindar una atención integral y de calidad. A continuación, presentamos algunas de nuestras alianzas más destacadas.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Certificaciones />

                    <div className="row justify-content-center mt-4">
                        <div className="col-12 text-center">
                            <a href="/certificaciones" className="btn btn-link text-primary fs-6">Conocer más <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section bg-inverted">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Dirección Médica</h4>
                                <p className="text-muted para-desc mx-auto mb-0">Nuestro equipo directivo está compuesto por profesionales dedicados y altamente capacitados, comprometidos con liderar el hospital hacia la excelencia en atención médica y servicio a la comunidad. Con experiencia en la gestión de instituciones de salud, nuestros directivos trabajan cada día para asegurar un entorno de calidad, innovación y humanidad en cada área de nuestra organización. A continuación, presentamos a quiénes están a cargo de la dirección de nuestro proyecto de salud.</p>
                            </div>
                        </div>
                    </div>
                    <Team />
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
